<template>
    <PageIntro v-editable="blok" :data="pageIntroData" />
</template>

<script setup lang="ts">
import type { PageIntroType } from '#shared/types/PageIntroType';
import PageIntro from '~/components/page-building/PageIntro.vue';

const props = defineProps({
    blok: {
        type: Object,
        required: true,
    },
    nextBlock: {
        type: Object,
        required: false,
        default: null,
    },
});

const pageIntroData = computed<PageIntroType>(() => {
    return {
        heading: props.blok.heading,
        content: richTextToHtml(props.blok.content) as string,
        buttons: props.blok.buttons ?? [],
        backgroundColor: props.blok.background_color,
        vertical: props.blok.vertical,
        textColor: props.blok.text_color,
        nextBackgroundColor: props.nextBlock
            ? props.nextBlock.background_color
            : null,
        bottomAngle: props.blok.bottom_angle,
        paddingBottom: props.blok.padding_bottom ?? 'normal',
        vEditable: props.blok,
    };
});
</script>
